import script from "./MCTextFormatter.vue?vue&type=script&setup=true&lang=js"
export * from "./MCTextFormatter.vue?vue&type=script&setup=true&lang=js"

import "./MCTextFormatter.vue?vue&type=style&index=0&id=6248330b&lang=css"

const __exports__ = script;

export default __exports__